import Login from '#AdminPanelFrontend/unauthorized/components/login';
import React from 'react';
import '../styles/globals.css';
import { ThemeProvider } from '#AdminPanelFrontend/components/theme-provider';

function Unauthorized() {
	return (
		<ThemeProvider defaultTheme="system" storageKey="ui-theme">
			<main className="app-main">
				<Login />
			</main>
		</ThemeProvider>
	);
}

export default Unauthorized;
